import { render, staticRenderFns } from "./ProjectInputSelect.vue?vue&type=template&id=055fb93f"
import script from "./ProjectInputSelect.vue?vue&type=script&lang=js"
export * from "./ProjectInputSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports